import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  getCurrentTradingTab,
  getTradingDaily,
  getTradingHst,
} from '!views/Trading/redux/trading.selectors';

export const useGridVirtualScrollingProps = () => {
  const tradingScreenRef = useRef(null);

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [firstOrderYPos, setFirstOrderYPos] = useState(0);

  const currentTab = useSelector(getCurrentTradingTab);
  const tradingData = useSelector(
    currentTab === 0 ? getTradingDaily : getTradingHst,
  );

  const ROWHEIGHT = 44;
  const ROWTOPMARGIN = 4;
  const PREVENTIONROWS = 3;

  const availableSpace = windowHeight - firstOrderYPos;
  const visibleRows =
    Math.ceil(availableSpace / (ROWHEIGHT + ROWTOPMARGIN)) + PREVENTIONROWS;

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  useLayoutEffect(() => {
    const firstOrderTopPos = tradingScreenRef.current
      ?.querySelector('.k-table-tbody')
      ?.getBoundingClientRect().top;

    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (firstOrderTopPos) setFirstOrderYPos(firstOrderTopPos);
  }, [tradingData.length]);

  return {
    tradingScreenRef,
    virtualScrollingProps: {
      rowHeight: ROWHEIGHT,
      pageSize: visibleRows,
      scrollable: 'virtual',
    },
  };
};
